import React from 'react';
import {Link} from 'react-router-dom';
import MainBanner from '../components/MainBanner';

interface PageBannerProps {
    activePage: string;
    parentPage: string;
    motherMenu: string;
    image?: string;
}

const PageBanner: React.FC<PageBannerProps> = (props) => {
    return (
            <section className="main-banner inner-banner" id="main-banner">
                <MainBanner />
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12">
                            <div className="banner-content">
                                <h1 className="h1-title wow fadeup-animation" data-wow-delay="0.2s">{props.activePage}</h1>
                                <div className="breadcrumb-box wow fadeup-animation" data-wow-delay="0.4s">
                                    <ul>
                                        <li><Link to={"#"}>{props.parentPage}</Link></li>
                                        <li>{props.motherMenu}</li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    );
};

export default PageBanner;